import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getDriversAppEntries($limit: Int, $offset: Int, $order: String, $where: String) {
    getDriversAppEntries(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        commandTypeId
        commandGuid
        driverId
        context
        vehicleId
        collectionPointId
        collectionId
        latitude
        longitude
        deviceInfo
        generatedId
        generatedTable
        processResultFlag
        processResultMsg
        firstDate
        lastDate
        firstUser
        lastUser
        collection {
          id
          code
        }
        collectionpoint {
          id
          name
          code
          addressLine1
          addressArea
          addressCity
        }
        driver {
          id
          name
          collectorId
          collector {
            id
            name
          }
        }
        vehicle {
          id
          plateNumber
        }
        commandType {
          id
          name
        }
      }
      recordCount
    }
  }
`;
